import logo from './logo.svg';
import React from "react";
import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { Fragment, useEffect, useState } from "react";
import style from "../src/style.css";

import Login from './components/Login/Login';
import LoginAdmin from './components/Login-Admin/LoginAdmin';
import NavbarTop from './components/Navbar/Navbar';
import Sidebar from "./components/Sidebar/Sidebar";

import CreatePublisher from './components/Add-Publisher/AddPublisher';
import AllPubList from './components/Publisher-List/PublisherList';
import AddDomains from './components/Add-Domain/AddDomain';
// import DomainList from './components/Domain-List/DomainList'
import DomainsList from './components/Domain-List/DomainList';
import EditDomain from './components/Edit-Domain/EditDomain'
import EditPublisher from './components/Edit-Publisher/EditPublisher'

import SummaryPanel from './components/Summary/Summary';
import ReportingPanel from './components/Reporting/Reporting';
import ProfilePage from './components/User-Profile/UserProfile';

import AdminAllReports from './components/Admin-Reporting/AdminReporting';

import CreateAdForm from './components/Create-Ad/CreateAd';
import AdList from './components/Ad-list/AdList';
import UpdateAd from './components/Update-AdPlacement/UpdateAd';

import ManageAdList from './components/Manage-Ad/ManageAd';

import OtherSettings from './components/Other-Setting/OtherSetting';
import UpdateOtherSettings from './components/Other-Setting/UpdateOtherSetting';

import Maintenance from '../src/Maintenance';
import { Navigate } from "react-router-dom"; 

function App() {
  const location = useLocation();

  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
 
   // ✅ Paths where we want to HIDE Navbar + Sidebar
  const hideLayout = ["/maintenance", "/admin", "/"];

  const shouldHideLayout = hideLayout.includes(location.pathname);
  // const [isLoggedIn, setIsLoggedIn] = useState(false);
  // useEffect(() => {
  //   debugger;
  //   const token = localStorage.getItem("token");
  //   if (token) {
  //     setIsLoggedIn(true); // If token exists, set logged in state to true
  //   }
  // }, []);
  return (
    <>
      {!shouldHideLayout && (
        <NavbarTop sidebarCollapsed={sidebarCollapsed} setSidebarCollapsed={setSidebarCollapsed} />
        )}
      {!shouldHideLayout && <Sidebar sidebarCollapsed={sidebarCollapsed} setSidebarCollapsed={setSidebarCollapsed}/>}
    {/* {isLoggedIn && <NavbarTop />} */}
          {/* <NavbarTop /> */}
          {/* <Sidebar /> */}
          <main className={!shouldHideLayout ? `main-content ${sidebarCollapsed ? "sidebar-collapsed" : ""}`: ""}>
            <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/admin" element={<LoginAdmin />} />
            <Route path="/add-publisher" element={<CreatePublisher />} />
            <Route path="/publisher-list" element={<AllPubList />} />
            <Route path="/summary" element={ localStorage.getItem("account_id") === "f3a15f06-c726-4056-a67b-ae96ad22e7e3" ? <Navigate to="/reporting" replace /> : <SummaryPanel /> } />
            <Route path="/reporting" element={<ReportingPanel />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/add-domain/:id" element={<AddDomains />} />
            <Route path="/edit-domain/:pubId/:domainId" element={<EditDomain />} />
            <Route path="/domain-list/:pubId" element={<DomainsList />} />
            <Route path="/create-ad/:pubId/" element={<CreateAdForm />} />
            <Route path="/update-ad/:pubId/:adunitId" element={<UpdateAd />} />
            {/* <Route path="/update-ad/:pubId/" element={<UpdateAd />} /> */}
            {/* <Route path="/create-ad/:pubId/:siteId" element={<CreateAdForm />} /> */}
            <Route path="/ad-list/:pubId/" element={<AdList />} />
            <Route path="/edit-publisher/:pubid" element={<EditPublisher />} />
            <Route path="/admin-reporting" element={<AdminAllReports />} />
            <Route path="/manage-ad/:pubId" element={<ManageAdList />} />
            <Route path="/other-setting/:pubId" element={<OtherSettings />} />
            <Route path="/update-other-setting/:pubId" element={<UpdateOtherSettings />} />
            <Route path="/maintenance" element={<Maintenance />} />
            {/* If someone types an invalid URL */}
            <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
    </>
  );
}

export default App;
